interface ListItemProps {
  id: string;
  primaryText: string;
  amount: number;
  isSelected: boolean;
  onClick: () => void;
}

const ListItem: React.FC<ListItemProps> = ({
  id,
  primaryText,
  amount,
  isSelected,
  onClick,
}) => {
  return (
    <div
      key={id}
      onClick={onClick}
      className={`flex justify-between items-center py-3 px-2 transition-all duration-200 rounded-[3px] cursor-pointer ${
        isSelected
          ? "border border-[#044E97] bg-blue-100"
          : "border border-transparent border-b border-b-gray-200 last:border-b-transparent hover:bg-slate-100"
      }`}
    >
      <span className="font-medium text-gray-900">{primaryText}</span>
      <span className="text-black font-medium">
        NGN {amount?.toLocaleString()}
      </span>
    </div>
  );
};

export default ListItem;
